module.exports = __webpack_public_path__ + "static/media/seal work1.b199e631.png";